// ── connections.js — BeeConnect friendly connection requests ─────────────
// Wraps all DB calls for the connection_requests table.

import { supabase } from './supabase';

// Send a connection request from current user to targetId
export async function sendConnectionRequest(fromId, toId, message = '') {
  if (!fromId || !toId || fromId === toId) return { error: 'invalid' };
  const { data, error } = await supabase
    ?.from('connection_requests')
    .insert({ from_user: fromId, to_user: toId, message: message || null })
    .select('id, status')
    .single();
  return { data, error };
}

// Accept a pending request (current user = to_user)
export async function acceptConnectionRequest(requestId, acceptorId) {
  const { error } = await supabase?.rpc('accept_connection_request', {
    p_request_id: requestId,
    p_acceptor_id: acceptorId,
  });
  return { error };
}

// Decline or cancel a request
export async function declineConnectionRequest(requestId, userId) {
  const { error } = await supabase?.rpc('decline_connection_request', {
    p_request_id: requestId,
    p_user_id: userId,
  });
  return { error };
}

// Fetch all requests for a user (sent + received)
export async function fetchConnectionRequests(userId) {
  if (!userId) return { sent: [], received: [] };
  const { data, error } = await supabase
    ?.from('connection_requests')
    .select('id, from_user, to_user, status, message, created_at')
    .or(`from_user.eq.${userId},to_user.eq.${userId}`)
    .order('created_at', { ascending: false });

  if (error || !data) return { sent: [], received: [], error };

  const sent     = data.filter(r => r.from_user === userId);
  const received = data.filter(r => r.to_user === userId);
  return { sent, received };
}

// Get the request status between two users (any direction)
export function getRequestStatus(requests, meId, otherId) {
  if (!requests) return null;
  const all = [...(requests.sent || []), ...(requests.received || [])];
  const r = all.find(
    x => (x.from_user === meId && x.to_user === otherId) ||
         (x.from_user === otherId && x.to_user === meId)
  );
  if (!r) return null;
  return { ...r, isSender: r.from_user === meId };
}
